import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { useNavigate } from 'react-router-dom';
import propTypes from 'prop-types';
import classes from './Banner.module.css';

const BANNER_TEXT = {
  title: 'Welcome John!',
  start: 'Start adding features that give shoppers peace of mind.',
};
export default function Banner({ name }) {
  const navigate = useNavigate();
  const handleClick = () => {
    navigate('/products');
  };
  return (
    <div className={classes.banner} onClick={handleClick}>
      <div className={classes.banner_tips}>
        <div>{`Welcome ${name}`}</div>
        <div>{BANNER_TEXT.start}</div>
      </div>
      <ChevronRightIcon />
    </div>
  );
}
Banner.propTypes = {
  name: propTypes.string.isRequired,
};
